export const RECEIVE_ITEM = "RECEIVE_ITEM";


export function receiveItem(item) {
  return {
    type: RECEIVE_ITEM,
    item
  };
}
